
export default {
  props: {
    colorFill: { type: String, default: "#302E2F" },
  },
};
